export const extractMovedTicket = (responseData) => responseData?.ticket || null;

export const UNASSIGNED_KANBAN_LANE_ID = "unassigned";

export const getUnassignedKanbanTickets = (tickets = [], stages = []) => {
  const stageIds = new Set(
    stages
      .map((stage) => Number(stage?.id))
      .filter((stageId) => Number.isInteger(stageId) && stageId > 0),
  );

  return tickets.filter(
    (ticket) =>
      !(ticket.tags || []).some((tag) => stageIds.has(Number(tag?.id))),
  );
};

export const replaceTicketInList = (tickets, movedTicket) => {
  if (!movedTicket?.id) {
    return tickets;
  }

  const movedTicketId = Number(movedTicket.id);
  let found = false;

  const nextTickets = tickets.map((ticket) => {
    if (Number(ticket.id) !== movedTicketId) {
      return ticket;
    }

    found = true;
    return { ...ticket, ...movedTicket };
  });

  return found ? nextTickets : [...tickets, movedTicket];
};
